import React from 'react';
import FileDownloadIcon from '@rsuite/icons/FileDownload';
import { CompactCell } from 'Components/Common/Table/CustomCells';
import DetailIcon from '@rsuite/icons/Detail';
import SendIcon from '@rsuite/icons/Send';
import { Popover, Dropdown, Whisper, IconButton } from 'rsuite';
import MoreIcon from '@rsuite/icons/legacy/More';

export const ActionCell = ({ rowData, dataKey, onSelect, ...props }) => {

  const  renderMenu = ({ onClose, left, top, className }, ref) => {

    const handleSelect = eventKey => {
      onClose();
      onSelect(eventKey, rowData);
    };
  
    return (
      <Popover ref={ref} className={className} style={{ left, top }} full>
        <Dropdown.Menu onSelect={handleSelect}>
          <Dropdown.Item icon={<FileDownloadIcon />} eventKey={1}>
            Exportar Json
          </Dropdown.Item>
          <Dropdown.Item icon={<FileDownloadIcon />} eventKey={2} disabled>
            Exportar PDF
          </Dropdown.Item>
          <Dropdown.Item icon={<FileDownloadIcon />} eventKey={3}>
            Exportar archivos (.zip)
          </Dropdown.Item>
          <Dropdown.Separator />
          <Dropdown.Item icon={<DetailIcon />} eventKey={4}>
            Ver detalles
          </Dropdown.Item>
          <Dropdown.Item icon={<SendIcon />} eventKey={5}>
            Enviar correo
          </Dropdown.Item>
        </Dropdown.Menu>
      </Popover>
    );
  
  }
  
  return (
    <CompactCell {...props}>
      <Whisper placement="autoVerticalEnd" trigger="click" speaker={renderMenu}>
        <IconButton size="xs" appearance="subtle" icon={<MoreIcon />}></IconButton>
      </Whisper>
    </CompactCell>
  );
};
